import type { QueryClient } from "@tanstack/react-query";
import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { fetchMediaAsset } from "@/lib/utils/media/fetch-media-asset";
import { getMediaAssetQueryKey } from "@/lib/utils/media/media-asset-query-key";

export async function prefetchClassRoomCoverMedia(
  queryClient: QueryClient,
  tenantId: number,
  classRoomId: number,
) {
  if (tenantId <= 0 || classRoomId <= 0) return queryClient;

  await queryClient.prefetchQuery({
    queryKey: getMediaAssetQueryKey(
      tenantId,
      EntryType.ClassRoom,
      classRoomId,
      MediaGroup.Cover,
      "public",
    ),
    queryFn: () =>
      fetchMediaAsset({
        tenantId,
        ownerType: "ClassRoom",
        ownerId: classRoomId,
        mediaGroup: MediaGroup.Cover,
      }).catch(() => ({
        url: null,
        mediaId: null,
        media: null,
      })),
  });

  return queryClient;
}
